import { render } from "./PromoView.vue?vue&type=template&id=dc792ee4&scoped=true"
import script from "./PromoView.vue?vue&type=script&lang=js"
export * from "./PromoView.vue?vue&type=script&lang=js"

import "./PromoView.vue?vue&type=style&index=0&id=dc792ee4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc792ee4"]])

export default __exports__